import { writable } from 'svelte/store';

export const notices_list = writable([]);
export const next_page_notices = writable(null);